import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '../../../../components/action-button';
import { useEntityDelete } from '../../../entities/hooks';
import { fetchEmailDelete } from '../../thunks';
import { IconDeleteCanOutline } from '../../../../common/icons';
import { ROUTE_EMAIL } from '../../../../common/constants';
import { IEmail } from '../../models';

interface EmailActionDeleteProps {
  id: IEmail['id'];
}

export const EmailActionDelete: FC<EmailActionDeleteProps> = ({ id }) => {
  const { t } = useTranslation();
  const { handleDelete } = useEntityDelete({
    thunk: fetchEmailDelete,
    nextPath: ROUTE_EMAIL,
    confirmationText: t('confirmation.delete.text'),
  });

  return (
    <ActionButton
      onClick={() => handleDelete(id)}
      title={t('action.delete')}
      icon={<IconDeleteCanOutline />}
    />
  );
};
